import * as types from "state/entities/subscriptionPlans/subscriptionPlansTypes";

export const initState = {
  pages: {},
  detailedIds: {},
  totalCount: null,
  pageSize: 100
};

const api = (state = initState, action) => {
  switch (action.type) {
    case types.FETCH_SUBSCRIPTION_PLANS: {
      const page = {
        [action.request.page]: {
          ...state.pages[action.request.page],
          isFetching: true
        }
      };

      return {
        ...state,
        pages: { ...state.pages, ...page }
      };
    }

    case types.FETCH_SUBSCRIPTION_PLANS_SUCCESS: {
      const {
        request: { page },
        response: { ids }
      } = action;
      const pages = {
        ...state.pages,
        [page]: {
          isFetching: false,
          ids: ids,
          didInvalidate: false
        }
      };

      return {
        ...state,
        pages: pages
      };
    }

    default:
      return state;
  }
};

export default api;
